export default __webpack_public_path__ + "static/media/squarespace-livingroom.c42e63ec.jpg";